const Kannada = {
  // COMMON
  language: "ಭಾಷೆ",
  date: "ದಿನಾಂಕ",
  time: "ಸಮಯ",
  price: "ಬೆಲೆ",
  month: "ತಿಂಗಳು",
  nearbyTemples: "ಹತ್ತಿರದ ದೇವಾಲಯಗಳು",
  createTemples: "ದೇವಾಲಯಗಳನ್ನು ರಚಿಸಿ",
  temples: "ದೇವಾಲಯಗಳು",
  latestTemples: "ಇತ್ತೀಚಿನ ದೇವಾಲಯಗಳು",
  groupOfTemples: "ದೇವಾಲಯಗಳ ಗುಂಪು",

  //DASHBOARD
  templeCreateDescription:
    "ದೇವಾಲಯ ಪ್ರೊಫೈಲ್ ರಚಿಸುವುದು ಸರಳ, ಅರ್ಥಪೂರ್ಣ ಮತ್ತು ಉಚಿತ. ನಿಮ್ಮ ದೇವಾಲಯದ ಕಥೆ ಇತರರನ್ನು ಪ್ರೇರೇಪಿಸಲಿ ಮತ್ತು ಬೆಳೆಯುತ್ತಿರುವ ಆಧ್ಯಾತ್ಮಿಕ ಜಾಲದ ಭಾಗವಾಗಿರಿ.",

  backToSearch: "ಹುಡುಕಾಟಕ್ಕೆ ಹಿಂತಿರುಗಿ",
  backToDashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ಗೆ ಹಿಂತಿರುಗಿ",
  templeView: "ದೇವಾಲಯ ವೀಕ್ಷಣೆ",
  editTemples: "ದೇವಾಲಯಗಳನ್ನು ಸಂಪಾದಿಸಿ",
  backToTemples: "ದೇವಾಲಯಗಳಿಗೆ ಹಿಂತಿರುಗಿ",
  profile: "ಪ್ರೊಫೈಲ್",
  personalInfo: "ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ",
  locationBackground: "ಸ್ಥಳ & ಹಿನ್ನೆಲೆ",
  spiritualIdentification: "ಆಧ್ಯಾತ್ಮಿಕ & ಗುರುತింపు",
  editProfile: "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
  profilePhoto: "ಪ್ರೊಫೈಲ್ ಫೋಟೋ",
  backToProfile: "ಪ್ರೊಫೈಲ್‌ಗೆ ಹಿಂತಿರುಗಿ",
  saveProfile: "ಪ್ರೊಫೈಲ್ ಉಳಿಸಿ",
  optional: "(ಐಚ್ಛಿಕ)",

  // TEMPLE
  templeGallery: "ದೇವಾಲಯ ಗ್ಯಾಲರಿ",
  mainDeity: "ಮುಖ್ಯ ದೇವತೆ",
  otherDeity: "ಇತರೆ ದೇವತೆಗಳು",
  location: "ಸ್ಥಳ",
  address: "ವಿಳಾಸ",
  city: "ನಗರ",
  district: "ಜಿಲ್ಲೆ",
  state: "ರಾಜ್ಯ",
  pincode: "ಪಿನ್ ಕೋಡ್",
  geographicCoordinates: "ಭೌಗೋಳಿಕ ಸಹಸಮಾನತೆಗಳು",
  cityTownVillage: "ನಗರ / ಪಟ್ಟಣ / ಗ್ರಾಮ",

  availableFacilities: "ಲಭ್ಯವಿರುವ ಸೌಲಭ್ಯಗಳು & ಪ್ರವೇಶ",
  ritualsGuidelines: "ಸಾಮಾನ್ಯ ಮಾಹಿತಿ",
  dressCode: "ಉಡುಪು ನಿಯಮ",
  festivalEvents: "ಹಬ್ಬಗಳು & ಕಾರ್ಯಕ್ರಮಗಳು",
  poojaDetails: "ಪೂಜೆ ವಿವರಗಳು",
  contactInfo: "ಸಂಪರ್ಕ ಮಾಹಿತಿ",
  templeTimings: "ದೇವಾಲಯ ಸಮಯ",
  morning: "ಬೆಳಗ್ಗೆ",
  afternoon: "ಮಧ್ಯಾಹ್ನ",
  sthalaVirutcham: "ಸ್ಥಳ ವಿಱುಚ್ಚಮ್",
  bestTime: "ಸಂದರ್ಶನಕ್ಕೆ ಉತ್ತಮ ಸಮಯ",
  atonementRituals: "ಈ ದೇವಾಲಯದಲ್ಲಿ ಪ್ರಾಯಶ್ಚಿತ್ತ ಆಚರಣೆಗಳು",
  howToReach: "ಹಾಗೆ ತಲುಪುವುದು",
  km: "ಕಿಮೀ",
  ownershipDetails: "ದೇವಾಲಯದ ಮಾಲೀಕತ್ವ ವಿವರಗಳು",
  managedBy: "ನಿರ್ವಹಣೆ",

  //TEMPLE CONTACT
  templeEmail: "ದೇವಾಲಯದ ಇಮೇಲ್ ವಿಳಾಸ",
  templeOwnershipContact: "ದೇವಾಲಯದ ಮಾಲೀಕತ್ವದ ಸಂಪರ್ಕ ಮಾಹಿತಿ",
  otherContactInfo: "ಇತರೆ ಸಂಪರ್ಕ ಮಾಹಿತಿ",

  // REVIEWS
  reviews: "ಅವಲೋಕನಗಳು",
  communityReviews: "ನಮ್ಮ ಸಮುದಾಯದಿಂದ ಅವಲೋಕನಗಳು",
  searchReviews: "ಅವಲೋಕನಗಳನ್ನು ಹುಡುಕಿ",
  reviewDetails: "ಅವಲೋಕನ ವಿವರಗಳು",
  review: "ಅವಲೋಕನ",
  noReviews: "ನಿಮ್ಮ ದೇವಾಲಯದ ಅನುಭವವನ್ನು ಹಂಚಿಕೊಳ್ಳುವ ಮೊದಲ ವ್ಯಕ್ತಿಯಾಗಿರಿ.",

  // EXPERIENCES
  userExperience: "ಅನುಭವಗಳು",
  shareYourExperience: "ನಿಮ್ಮ ಅನುಭವವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
  communityExperiences: "ನಮ್ಮ ಸಮುದಾಯದ ಅನುಭವಗಳು",
  searchExperiences: "ಅನುಭವಗಳನ್ನು ಹುಡುಕಿ",
  experienceDetails: "ಅನುಭವ ವಿವರಗಳು",
  search: "ಹುಡುಕಿ",

  // SUGGESTIONS
  suggestUpdate: "ನವೀಕರಣವನ್ನು ಸೂಚಿಸಿ",
  helpImprove1: "ನಾವು ತಪ್ಪಿಸಿರುವ ಯಾವುದಾದರೂ ವಿಷಯ ನಿಮಗೆ ಗೊತ್ತಿದೆಯೆ",
  helpImprove2:
    "ಮಾಹಿತಿಯನ್ನು ನಿಖರವಾಗಿರಿಸಲು ಮತ್ತು ನವೀಕರಿಸಲು ನಿಮ್ಮ ಸಲಹೆಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಿ.",
  suggestion: "ಸಲಹೆ",
  referenceLink: "ಉಲ್ಲೇಖ ಲಿಂಕ್",
  otherGroupTemples: "ಈ ಗುಂಪಿನ ಇತರ ದೇವಾಲಯಗಳು",

  // BUTTONS
  viewAllTemples: "ಎಲ್ಲಾ ದೇವಾಲಯಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
  getDirection: "ದಿಕ್ಕು ಪಡೆಯಿರಿ",
  website: "ದೇವಾಲಯ ವೆಬ್‌ಸೈಟ್",
  writeReview: "ಅವಲೋಕನವನ್ನು ಬರೆಯಿರಿ",
  addSuggestion: "ಸಲಹೆ ಸೇರಿಸಿ",
  next: "ಮುಂದೆ",
  previous: "ಹಿಂದೆ",
  cancel: "ರದ್ದುಮಾಡಿ",
  submit: "ಸಲ್ಲಿಸು",
  updatePassword: "ಪಾಸ್‌ವರ್ಡ್ ನವೀಕರಿಸಿ",
  updateNow: "ಈಗ ನವೀಕರಿಸಿ",

  // INPUT
  name: "ಹೆಸರು",
  phoneNumber: "ಫೋನ್ ನಂಬರ್",

  // PROFILE
  currentPassword: "ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್",
  newPassword: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್",
  confirmNewPassword: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
  firstName: "ಮೊದಲ ಹೆಸರು",
  lastName: "ಕೊನೆಯ ಹೆಸರು",
  fullName: "ಪೂರ್ಣ ಹೆಸರು",
  dateOfBirth: "ಜನನ ದಿನಾಂಕ",
  age: "ವಯಸ್ಸು",
  gender: "ಲಿಂಗ",
  email: "ಇಮೇಲ್ ವಿಳಾಸ",
  phone: "ಫೋನ್ ನಂಬರ್",
  bio: "ಜೀವನಚರಿತ್ರೆ",
  religion: "ಧರ್ಮ",
  visitFrequency: "ಸಂದರ್ಶನ ಸಾಮಾನ್ಯತೆ",
  maritalStatus: "ವೈವಾಹಿಕ ಸ್ಥಿತಿ",
  aadhaarNumber: "ಆಧಾರ್ ನಂಬರ್",
  passportNumber: "ಪಾಸ್‌ಪೋರ್ಟ್ ನಂಬರ್",
  occupation: "ವೃತ್ತಿ",
  bloodGroup: "ರಕ್ತ ಗುಂಪು",

  // EMPTY
  noGuidelines: "ಮಾರ್ಗದರ್ಶಿ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ.",
  noDressCode: "ಉಡುಪು ನಿಯಮ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ.",
  noAtonementRituals: "ಈ ದೇವಾಲಯದಲ್ಲಿ ಪ್ರಾಯಶ್ಚಿತ್ತ ಆಚರಣೆಗಳು ಲಭ್ಯವಿಲ್ಲ.",
  noTransport: "ಹತ್ತಿರದ ಸಾರಿಗೆ ಆಯ್ಕೆಗಳು ಲಭ್ಯವಿಲ್ಲ.",
  noFestivalEvents: "ಹಬ್ಬ ಅಥವಾ ಕಾರ್ಯಕ್ರಮದ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
  noPoojaData: "ಪೂಜೆ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
  noOwnershipData: "ಮಾಲೀಕತ್ವದ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
  noContactData: "ಸಂಪರ್ಕ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
  noTempleImages: "ದೇವಾಲಯದ ಚಿತ್ರಗಳು ಲಭ್ಯವಿಲ್ಲ.",

  // COMMON
  shareTemple: "ಈ ದೇವಾಲಯವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
  copied: "ನಕಲಿಸಲಾಗಿದೆ!",
  note: "ಗಮನಿಸಿ:",
  passwordNote:
    "ನೀವು ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಿದ ನಂತರ, ಭದ್ರತಾ ಕಾರಣಗಳಿಂದ ನೀವು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಲಾಗಿನ್ ಪುಟಕ್ಕೆ ಹೋಗಲಿದ್ದು. ಮುಂದುವರೆಯಲು ನಿಮ್ಮ ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ಬಳಸಿ ಸೈನ್ ಇನ್ ಮಾಡಿ.",
};
export default Kannada;
